import type { VoidFunctionComponent } from 'react';
import styles from './Fallback.module.less';
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic/Button';
import Flex from '../../../generic/Flex';
import { Icon, icons } from '../../../generic';

type Props = {
  onConnectToService: () => void;
};

const ConnectToServiceFallback: VoidFunctionComponent<Props> = ({ onConnectToService }) => {
  return (
    <div className={styles.fallback}>
      <Flex gap="8px" direction="column">
        <Icon icon={icons.github} size="fa-3x" />
        <div className={styles.title}>Authorize Github</div>
        <div className={styles.description}>We need authorization to access your Github account.</div>
      </Flex>
      <Button type={BUTTON_TYPE.PRIMARY} size={BUTTON_SIZE.MEDIUM} onClick={onConnectToService}>
        Connect to Github
      </Button>
    </div>
  );
};

export default ConnectToServiceFallback;
